$(document).ready(function(){

  // fixed header
  var yourNavigation = $(".header-wrapper");
  stickyDiv = "header-fix";
  yourHeader = $('.header-top').height();

  $(window).scroll(function() {
    if( $(this).scrollTop() > yourHeader ) {
      yourNavigation.addClass(stickyDiv);
    } else {
      yourNavigation.removeClass(stickyDiv);
    }
  });


  $(window).scroll(function(){ 
    if ($(this).scrollTop() > 600) {
      $('#scroll').fadeIn(); 
    } else { 
      $('#scroll').fadeOut(); 
    } 
  }); 
  $('#scroll').click(function(){ 
    $("html, body").animate({ scrollTop: 0 }, '600'); 
    return false; 
  });
  
  setTimeout( function(){
    $(document).on('click','.pagination__list .pagination__item',function(){
      if (document.body.classList.contains('celluma')) return;
      $("html, body").animate({ scrollTop: 0 }, '600');
      return false;
    });
  }  , 2000 );  


  $(".header__icon .user-block").click(function(){
    $(this).toggleClass("active");
  });
  
  $(".select-for-radio select").change(function(){
    var value = $(this).val();
    var find_radio = $(this).parents('.product-form__input').find("input:radio[data-value="+value+"]").val();
    $(this).parents('.product-form__input').find("input:radio").attr('checked',false);
    if(find_radio){
      $(this).parents('.product-form__input').find("input:radio[data-value="+value+"]").attr('checked', 'checked');
    }
    //console.log(find_radio);
  });

  $('.about-brand-logo .about-brand-logomain').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $(window).scroll(function(){
    var sticky = $('.banner-block.slider-banner,.inner-page-banner'),
        scroll = $(window).scrollTop();

    if (scroll >= 100) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });

  //faq
  
 setTimeout( function(){ 
     
    var curr_lang = $('#LocaleSelector').val();
     
    $('#main-collection-filters .boost-pfs-filter-options-wrapper .boost-pfs-filter-option').each(function(i, li) {
      
      if(curr_lang == 'de'){        

        $('.boost-pfs-filter-option.boost-pfs-filter-option-traitements').hide();
        $('.boost-pfs-filter-option.boost-pfs-filter-option-trattamenti').hide();
        
        
      }
      
      if(curr_lang == 'fr'){  
        $('.boost-pfs-filter-option.boost-pfs-filter-option-trattamenti').hide();
        $('.boost-pfs-filter-option.boost-pfs-filter-option-behandlungen').hide();
        
        
        $('.boost-pfs-filter-option.boost-pfs-filter-option-hersteller .boost-pfs-filter-option-title-text').text('Producteur');
        $('.boost-pfs-filter-option.boost-pfs-filter-option-preis .boost-pfs-filter-option-title-text').text('Prix');
        $('.boost-pfs-filter-option.boost-pfs-filter-option-kategorien .boost-pfs-filter-option-title-text').text('Catégories');
      }
      
      if(curr_lang == 'it'){              
        $('.boost-pfs-filter-option.boost-pfs-filter-option-behandlungen').hide();
        $('.boost-pfs-filter-option.boost-pfs-filter-option-traitements').hide();
        
        
        $('.boost-pfs-filter-option.boost-pfs-filter-option-hersteller .boost-pfs-filter-option-title-text').text('Produttore');
        $('.boost-pfs-filter-option.boost-pfs-filter-option-preis .boost-pfs-filter-option-title-text').text('Prezzo');
        $('.boost-pfs-filter-option.boost-pfs-filter-option-kategorien .boost-pfs-filter-option-title-text').text('Categorie');
      }
     
    });
   
   }  , 2000 );  
     
});
